import { render, staticRenderFns } from "./PrescriptionSelectorModal.vue?vue&type=template&id=c48cfa5a"
import script from "./PrescriptionSelectorModal.vue?vue&type=script&lang=js"
export * from "./PrescriptionSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionSelectorModal.vue?vue&type=style&index=0&id=c48cfa5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports